import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { getSubdomainHelper } from 'src/helpers/getSubdomainHelper';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

// The help center's domain; pasted URLs are reduced to it.
export const ZendeskHelpCenterDomain = ({
  control,
}: {
  control: Control<ZendeskHelpCenterFormValues>;
}) => (
  <Controller
    control={control}
    name="domain"
    render={({ field: { onChange, value }, fieldState: { error } }) => (
      <Input
        type={'text'}
        label={'Zendesk help center domain'}
        placeholder={'.domain.com'}
        invalidMessage={error?.message}
        value={value}
        isValid={!error?.message}
        onChange={(e) => {
          const res = getSubdomainHelper(e.target.value);
          if (res?.subdomain && res?.domain) {
            onChange(`${res?.subdomain}.${res?.domain}`);
          } else if (res?.domain) {
            onChange(res?.domain);
          } else {
            onChange(e.target.value);
          }
        }}
        infoTooltip={{
          side: 'right',
          description: <>Link to your Zendesk Help Center</>,
        }}
      />
    )}
  />
);
